'use strict';
var React = require('react');
var assetsHelper = require('../helper/assetsHelper');

var PageIcons = {
  'psWhite': assetsHelper.getAsset('tree_icon_white.png'),
  'psBlue': assetsHelper.getAsset('tree_icon_blue.png'),
  'psGreen': assetsHelper.getAsset('tree_icon_green.png'),
  'psRed': assetsHelper.getAsset('tree_icon_red.png'),
  'psYellow': assetsHelper.getAsset('tree_icon_yellow.png')
};

var CurrentPageIcons = {
  'psWhite': assetsHelper.getAsset('tree_icon_white2.png'),
  'psBlue': assetsHelper.getAsset('tree_icon_blue2.png'),
  'psGreen': assetsHelper.getAsset('tree_icon_green2.png'),
  'psRed': assetsHelper.getAsset('tree_icon_red2.png'),
  'psYellow': assetsHelper.getAsset('tree_icon_yellow2.png')
};

function getIcon(status, isCurrent) {
  if (isCurrent) {
    return PageIcons[status] || PageIcons.psWhite;
  }
  return CurrentPageIcons[status] || CurrentPageIcons.psWhite;
}

var ModuleIcon = {
  'open': assetsHelper.getAsset('tree_icon_floder_open.png'),
  'closed': assetsHelper.getAsset('tree_icon_floder.png')
};

var ParentIcon = {
  'open': assetsHelper.getAsset('tree_open.png'),
  'closed': assetsHelper.getAsset('tree_closed.png')
};

/**
 * 页面
 */
var Page = React.createClass({
  propTypes: {
    node: React.PropTypes.object.isRequired,
    show: React.PropTypes.bool.isRequired,
    current: React.PropTypes.string.isRequired
  },
  render: function () {
    var node = this.props.node;
    var current = this.props.current;
    var className = '';
    var style = {};
    var isCurrent = node.ID === current;
    if (isCurrent) {
      className = 'current';
    }
    if (!this.props.show) {
      style.display = 'none';
    }
    return (
      <li className={className}
          key={node.ID}
          style={style}
          onClick={this.onSelectPage}>
        <span className='node-name'><img width="10" height="14" src={getIcon(node.status, isCurrent)}/>{node.name}</span>
        {
          node._pages && node._pages.length &&
          <ul>
            {node._pages.map(function (subNode) {
              return (
                <Page node={subNode}
                      current={current}
                      onSelectPage={this.props.onSelectPage}/>
              );
            }, this)}
          </ul>
        }
      </li>
    );
  },
  onSelectPage: function (e) {
    this.props.onSelectPage(this.props.node.ID);
    e.stopPropagation();
  }
});

/**
 * 模块
 */
var Module = React.createClass({
  propTypes: {
    root: React.PropTypes.bool,
    node: React.PropTypes.object.isRequired,
    show: React.PropTypes.bool.isRequired,
    current: React.PropTypes.string.isRequired
  },
  getInitialState: function () {
    return {
      expand: this.props.root
    };
  },
  render: function () {
    var showItem = this.state.expand || false;
    var style = {};
    var statusPath;
    var currentClassName = 'module';
    var statusClassName = 'status';
    var pages;

    if (this.props.root) {
      currentClassName += ' root';
    }

    if (!this.props.show) {
      style.display = 'none';
    }

    if (this.state.expand) {
      statusPath = ParentIcon.open;
    } else {
      statusPath = ParentIcon.closed;
      statusClassName += ' closed';
    }

    pages = this.props.node._pages;

    return (
      <li className={currentClassName} style={style}>
        <i className={statusClassName} onClick={this.onToggleExpand}>
          <img src={statusPath}/>
        </i>
        {this.renderNameWithIcon()}
        <ul>
          {
            pages && pages.map(function (node) {
              if (node.isModule || node._pages) {
                return (
                  <Module node={node}
                          key={node.ID}
                          show={showItem}
                          current={this.props.current}
                          onSelectPage={this.props.onSelectPage}/>
                );
              }
              return (
                <Page key={node.ID}
                      show={showItem}
                      node={node}
                      current={this.props.current}
                      onSelectPage={this.props.onSelectPage}/>
              );
            }, this)
          }
        </ul>
      </li>
    );
  },
  renderNameWithIcon: function () {
    var iconPath;
    var nodeNameClassName = 'node-name';
    var iconSize;
    var nodeName = this.props.node.name;
    if (this.props.node.isModule && this.props.node.childCount > 0) {
      nodeName += ' (' + this.props.node.childCount + ')';
    }

    if (this.props.node.isModule) {
      iconPath = ModuleIcon[this.state.expand ? 'open' : 'closed'];
      iconSize = {
        width: 16,
        height: 16
      };
    } else {
      iconPath = getIcon(this.props.node.status, this.props.node.ID === this.props.current);
      iconSize = {
        width: 10,
        height: 14
      };
    }

    if (this.props.node.ID === this.props.current) {
      nodeNameClassName += ' current';
    }
    return (
      <span className={nodeNameClassName} onClick={this.onClick} onDoubleClick={this.onToggleExpand}><img width={iconSize.width}
                                                                      height={iconSize.height}
                                                                      src={iconPath}/>{nodeName}</span>
    );
  },
  /**
   * 切换子项是否展开
   */
  onClick: function (e) {
    if (this.props.node.isModule) {
      this.onToggleExpand(e);
    } else {
      this.props.onSelectPage(this.props.node.ID);
    }
    e.stopPropagation();
  },
  onToggleExpand: function (e) {
    this.setState({
      expand: !this.state.expand
    });
    e.stopPropagation();
  }
});

/**
 * 项目树
 */
var Tree = React.createClass({
  propTypes: {
    name: React.PropTypes.string.isRequired,
    modules: React.PropTypes.object.isRequired,
    current: React.PropTypes.object.isRequired,
    onSelectPage: React.PropTypes.func.isRequired
  },
  render: function () {
    return (
      <div className="tree">
        <ul>
          <Module
            root={true}
            node={{
            isModule: true,
            name: this.props.name,
            _pages: this.props.modules._pages,
            childCount: this.props.modules.childCount
          }}
            show={true}
            current={this.props.current.ID}
            onSelectPage={this.props.onSelectPage}/>
        </ul>
      </div>
    );
  }
});

module.exports = Tree;


/** WEBPACK FOOTER **
 ** ./src/views/Tree.jsx
 **/